import BaseComponent from '../../../../base/base_component';
import Model from './generic_reality_check_component_model';

let generic_view = require('./view/generic_reality_check.html');
let session_cooldown_view = require('./view/session_cooldown_reality_check.html');

let view = generic_view;

export default class GenericRealityCheckComponent extends BaseComponent {
  static CLASS = 'GenericRealityCheckComponent';

  _model = null;

  init(params) {
    super.init(params);
    this._model = Model.create(params);
  }

  start() {

    if (this.serviceFactory.regulationService().isSessionCooldownEnabled()) {
      view = session_cooldown_view;
    }

    let bakedHTML = this.bake(view, {
      elapsed_time: this._formatTime(this._model.getElapsedTime()),
      session_balance: this.serviceFactory.currencyService().formatMoney(this._model.getSessionBalance()),
      session_balance_description: this._model.getSessionBalanceDescription(),
    });
    this.setHTML(bakedHTML);

    return this;
  }

  _formatTime(time) {
    return time.hours.toString().padStart(2, '0') + 'h:' + time.minutes.toString().padStart(2, '0') + 'm';
  }
}
